import React from 'react'
import { Table, OverlayTrigger, } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import BlogsLodingSkeleton from './table__loadingSkeleton'
import { renderTooltipDelete, renderTooltipEdit } from '../tooltips/CustomerGroups__Tooltips'

export default function CustomerGroupTable(props) {
    return (
        <Table responsive className="mb-0">
            <thead>
                <tr>
                    <th width={35}>
                        <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                            <input
                                type="checkbox"
                                className="d-none"
                                checked={props.allCheckboxSelected}
                                onChange={ev => props.handleSelectAllChange(ev)} />
                            <span className="box d-flex align-items-center justify-content-center border" style={{ height: 17, width: 17 }}>
                                <FeatherIcon
                                    icon="check"
                                    size="11"
                                    className="icon position-relative" />
                            </span>
                        </label>
                    </th>
                    {
                        props.column__GroupName && (
                            <th>
                                <p className="text-capitalize">
                                    Group
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__DiscountPercent && (
                            <th>
                                <p className="text-capitalize">
                                    Discount Percent
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__DiscountValue && (
                            <th>
                                <p className="text-capitalize">
                                    Discount Value
                                </p>
                            </th>
                        )
                    }

                    {
                        props.column__Status && (
                            <th>
                                <p className="text-capitalize">
                                    Status
                                </p>
                            </th>
                        )
                    }



                    <th width="90"></th>
                </tr>
            </thead>

            <tbody>
                {props.loading && (
                    <React.Fragment>
                        {
                            (props.loadingCount && props.loadingCount.length) && props.loadingCount.map(item => (
                                <React.Fragment key={item}>
                                    <BlogsLodingSkeleton />
                                </React.Fragment>
                            ))
                        }
                    </React.Fragment>
                )}

                {(props.customerGroups && props.customerGroups.length > 0) ? props.customerGroups.map(item => (
                    <tr key={item.group_id}>
                        <td className="column__checkbox">
                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox" />
                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 17, width: 17 }}>
                                    <FeatherIcon
                                        icon="check"
                                        size="11"
                                        className="icon position-relative" />
                                </span>
                            </label>
                        </td>

                        {props.column__GroupName && (
                            <td className="column__GroupName">
                                <p className="">
                                    {item.group_name}
                                </p>
                            </td>
                        )}

                        {props.column__DiscountPercent && (
                            <td className="column__DiscountPercent">
                                <p className="">
                                    {item.discount_percent ? "Yes" : "No"}
                                </p>
                            </td>
                        )}

                        {props.column__DiscountValue && (
                            <td className="column__DiscountValue">
                                <p className="">
                                    {item.discount_value}
                                </p>
                            </td>
                        )}

                        {props.column__Status && (
                            <td className="column__Status">
                                <p className="">
                                    {item.active ? "Active" : "Inactive"}
                                </p>
                            </td>
                        )}

                        <td className="column__actions">
                            <div className="d-flex justify-content-end">
                                <OverlayTrigger
                                    placement={"left"}
                                    trigger={['hover', 'focus', 'click']}
                                    overlay={renderTooltipEdit}
                                >
                                    <Link
                                        to={{
                                            pathname: '/customers/group/edit/' + item.group_id,
                                            state: { customerGroupDetails: item }
                                        }}
                                        className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center me-1"
                                    >
                                        <FeatherIcon
                                            icon="edit-2"
                                            size="15"
                                            className="icon" />
                                    </Link>
                                </OverlayTrigger>

                                <OverlayTrigger
                                    placement={"left"}
                                    overlay={renderTooltipDelete}
                                >
                                    <button
                                        className="st-round-btn st-btn-transparent st-btn-xs d-flex align-items-center justify-content-center"
                                        onClick={ev => props.handleDelete(ev, item.group_id)}
                                    >
                                        <FeatherIcon
                                            icon="trash"
                                            size="15"
                                            className="icon" />
                                    </button>
                                </OverlayTrigger>
                            </div>
                        </td>
                    </tr>
                )) : (
                    !props.loading ? (
                        <tr>
                            <td colSpan="7">
                                <p className="no-data-found text-center st-fw-700 py-1">
                                    No Data Found
                                </p>
                            </td>
                        </tr>
                    ) : null
                )
                }
            </tbody>
        </Table>
    )
}
